module.exports = __webpack_public_path__ + "assets/img/Group 1877.a26d9db3.png";